import { useEffect } from 'react';

/**
 * Custom hook to lock/unlock body scroll
 * Used for mobile menus and drawers
 */
export const useBodyScrollLock = (isLocked) => {
  useEffect(() => {
    if (isLocked) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.setProperty('overflow', 'hidden', 'important');
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      document.body.style.removeProperty('overflow');
      document.body.style.paddingRight = '';
    }

    return () => {
      document.body.style.removeProperty('overflow');
      document.body.style.paddingRight = '';
    };
  }, [isLocked]);
};

